export default class QueueEntry {

  private _comment: string;
  public get comment() { return this._comment; }

  private _location: string;
  public get location() { return this._location; }

  private _starttime: number;
  public get starttime() { return this._starttime; }

  private _gettinghelp: boolean;
  public get gettinghelp() { return this._gettinghelp; }

  private _helpstarttime: number | null;
  public get helpstarttime() { return this._helpstarttime; }

  private _helper: string;
  public get helper() { return this._helper; }

  private _helperProviderId: string;
  public get helperProviderId() { return this._helperProviderId; }

  private _help: boolean;
  public get help() { return this._help; }

  private _badlocation: boolean;
  public get badlocation() { return this._badlocation; }

  private _username: string;
  public get username() { return this._username; }

  private _providerId: string;
  public get providerId() { return this._providerId; }

  private _realname: string;
  public get realname() { return this._realname; }

  private _bookingTime: string | null;
  public get bookingTime() { return this._bookingTime; }

  private _bookingHelp: boolean | null;
  public get bookingHelp() { return this._bookingHelp; }

  // >>> call-dibs feature (revertible) >>>
  private _claimed: boolean;
  public get claimed() { return this._claimed; }
  // <<< call-dibs feature <<<

  public constructor(data: any) {
    this._comment = data.comment || '';
    this._location = data.location || '';
    this._starttime = data.starttime || 0;
    this._gettinghelp = data.gettinghelp || false;
    this._helpstarttime = data.helpstarttime ? new Date(data.helpstarttime).getTime() : null;
    this._helper = data.helper || '';
    this._helperProviderId = data.helper_provider_id || '';
    this._help = data.help || false;
    this._badlocation = data.badlocation || false;
    this._username = data.username || '';
    this._providerId = data.provider_id || '';
    this._realname = data.realname || '';
    this._bookingTime = data.booking_time || null;
    this._bookingHelp = data.booking_help != null ? data.booking_help : null;
    // >>> call-dibs feature (revertible) >>>
    this._claimed = data.claimed || false;
    // <<< call-dibs feature <<<
  }

  public clone(): QueueEntry {
    return new QueueEntry({
      comment: this._comment,
      location: this._location,
      starttime: this._starttime,
      gettinghelp: this._gettinghelp,
      helpstarttime: this._helpstarttime ? new Date(this._helpstarttime).toISOString() : null,
      helper: this._helper,
      helper_provider_id: this._helperProviderId,
      help: this._help,
      badlocation: this._badlocation,
      username: this._username,
      provider_id: this._providerId,
      realname: this._realname,
      booking_time: this._bookingTime,
      booking_help: this._bookingHelp,
      // >>> call-dibs feature (revertible) >>>
      claimed: this._claimed,
      // <<< call-dibs feature <<<
    });
  }
}
